import { render, staticRenderFns } from "./TableUserColumn.vue?vue&type=template&id=b0a70008&scoped=true"
import script from "./TableUserColumn.vue?vue&type=script&lang=js"
export * from "./TableUserColumn.vue?vue&type=script&lang=js"
import style0 from "./TableUserColumn.vue?vue&type=style&index=0&id=b0a70008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a70008",
  null
  
)

export default component.exports